export type TSubdomain = "constellation" | "troubadour" | "family" | "other";

export class HostDetector {
  private static hostname: string = location.hostname;

  public static GetSubdomain(): TSubdomain {
    // Extract the first part of the hostname (subdomain)
    const parts = this.hostname.split(".");

    // Validate hostname structure: should be exactly 3 parts (subdomain.domain.tld)
    if (parts.length !== 3) {
      return "other";
    }

    const subdomain = parts[0];

    // Exact subdomain matches
    if (subdomain === "troubadour") {
      return "troubadour";
    }
    if (subdomain === "family") {
      return "family";
    }
    if (subdomain === "constellation") {
      return "constellation";
    }

    return "other";
  }

  public static IsConstellation(): boolean {
    return this.GetSubdomain() === "constellation";
  }

  public static IsTroubadour(): boolean {
    return this.GetSubdomain() === "troubadour";
  }

  public static IsFamily(): boolean {
    return this.GetSubdomain() === "family";
  }

  public static GetHostname(): string {
    return this.hostname;
  }
}
